import React from 'react';
import { CinematicScene } from '../CinematicScene';
import { Reveal } from '../Reveal';
import { ActionButton } from '../ActionButton';
import { imagery, visitInfo } from '../../data/site';
import { MotionMode } from '../../types/motion';
interface VisitSceneProps {
  motionMode?: MotionMode;
}
export function VisitScene({
  motionMode = 'cinematic'
}: VisitSceneProps) {
  return <CinematicScene id="visit" image={imagery.visit} imageAlt="The corner storefront at night, warm light spilling onto the street" motionMode={motionMode} scrim="center" height="tall" data-id="element-123" data-mp="p9y7xtt5dg6i">
      <div className="mx-auto flex h-full max-w-3xl flex-col items-center justify-center px-6 text-center md:px-10" data-id="element-124" data-mp="g8gp43ocv0e4">
        <Reveal data-id="element-125" data-mp="b9dm0orxr48s">
          <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.3em] text-brass" data-id="element-126" data-mp="b9x72ecvu8r1">
            Visit Us
          </p>
        </Reveal>

        <Reveal delay={0.12} data-id="element-127" data-mp="2vzuw2bibqlr8">
          <h2 className="font-display text-[2.4rem] font-normal leading-[1.1] tracking-wide text-cream md:text-6xl" data-id="element-128" data-mp="2vzmj6jm7bgg1">
            YOUR TABLE IS READY.
          </h2>
        </Reveal>

        <Reveal delay={0.24} data-id="element-129" data-mp="b3z6r93jtgjx">
          <p className="mt-5 font-mono text-[12.5px] text-stone md:text-[13px]" data-id="element-130" data-mp="b35w3x1gy6wi">
            Join us for your morning ritual or your afternoon escape.
          </p>
        </Reveal>

        <Reveal delay={0.36} data-id="element-131" data-mp="21pv2fwjnh4y">
          <dl className="mt-11 flex flex-col items-center gap-8 sm:flex-row sm:items-start sm:gap-14" data-id="element-132" data-mp="253zdtorq0f1">
            <div data-id="element-133" data-mp="3jhehak1nvven">
              <dt className="mb-2 font-mono text-[9.5px] uppercase tracking-[0.25em] text-brass" data-id="element-134" data-mp="3oa7l95pb2zpo">
                Location
              </dt>
              <dd className="font-mono text-[11.5px] leading-[1.8] text-stone" data-id="element-135" data-mp="3ak44uvd3y085">
                {visitInfo.location.map(line => <span key={line} className="block" data-id="element-136" data-mp="3fft9hd3zi7bb">
                    {line}
                  </span>)}
              </dd>
            </div>

            <div aria-hidden="true" className="hidden h-12 w-px bg-hair sm:block" data-id="element-137" data-mp="35iok74eudvqa" />

            <div data-id="element-138" data-mp="2mgfo94nth2y1">
              <dt className="mb-2 font-mono text-[9.5px] uppercase tracking-[0.25em] text-brass" data-id="element-139" data-mp="2mgxtgqsgiri3">
                Hours
              </dt>
              <dd className="font-mono text-[11.5px] leading-[1.8] text-stone" data-id="element-140" data-mp="2coibhth5u2x7">
                {visitInfo.hours.map(line => <span key={line} className="block" data-id="element-141" data-mp="27rrvf65cv7bs">
                    {line}
                  </span>)}
              </dd>
            </div>
          </dl>
        </Reveal>

        <Reveal delay={0.48} data-id="element-142" data-mp="30g79nqgnxlm2">
          <div className="mt-11 flex flex-col items-center gap-4 sm:flex-row sm:gap-5" data-id="element-143" data-mp="30ct4kagm6yax">
            <ActionButton href={visitInfo.directionsUrl} external data-id="element-144" data-mp="2vdyeqok8c9hb">
              Get Directions
            </ActionButton>
            <a href="#map" className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone transition-colors hover:text-brass" data-id="element-145" data-mp="2qj2n3piwno4q">
              See the map
            </a>
          </div>
        </Reveal>
      </div>
    </CinematicScene>;
}